import React from 'react';
import isEmpty from 'lodash/isEmpty';
import ContentWrap from 'core/modules/Partials/ContentWrap/ContentWrap';
import ComponentErrorBoundary from 'core/modules/ErrorBoundaries/ComponentErrorBoundary';
import { parseBonusButton } from 'core/modules/BonusButton/utils/parseBonusButton';
import { useGetBonusButton } from 'core/modules/BonusButton/hooks/useGetBonusButton';

import './BonusButtonTerms.scss';

function BonusButtonTerms() {
  const { placement } = useGetBonusButton(true);
  const { terms, isEnded } = parseBonusButton(placement);

  if (isEmpty(placement) || isEnded) return null;

  const termsWithAsterisk = `<span class="mn_asterisk">*</span>${terms}`;

  return (
    <div className="mn_bonusButtonTerms">
      <ContentWrap>
        <div className="mn_termsInfo" dangerouslySetInnerHTML={{ __html: termsWithAsterisk }} />
      </ContentWrap>
    </div>
  );
}

export default (props) => <ComponentErrorBoundary><BonusButtonTerms {...props} /></ComponentErrorBoundary>;
